
    <div [ngSwitch]="layout">
      <!-- ========================================================================== -->
      <!-- Table Layout                                                               -->
      <!-- ========================================================================== -->
      <div *ngSwitchCase="'table'">
        <div
          [ngClass]="{
            'div-table-tr': options?.index % 2 == 1,
            'div-table-tr-alt': options?.index % 2 == 0
          }"
        >
          <div class="row" (click)="showEditModal(defaultView, entity, $event)">
            <div class="col-3 text-left">#{{ entity?.identifier }}</div>
            <div class="col-3 text-left">{{ entity?.manufacturerId }}</div>
            <div class="col-3 text-left">{{ entity?.series }}</div>
            <div class="col-3 text-left">{{ entity?.firmwareVersion }}</div>
          </div>
        </div>
      </div>

      <!-- ========================================================================== -->
      <!-- Default                                                                    -->
      <!-- ========================================================================== -->
      <div *ngSwitchDefault>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div *ngIf="entity">
                <!-- put link to manufacturer -->
                <div class="card-header">
                  <strong>Firmware Definition:</strong>
                  <span> Version ({{ entity?.firmwareVersion }}) </span>
                  <span>
                    {{ getManufacturerDescription(entity?.manufacturerId) }}
                  </span>
                </div>
                <div class="card-body m-1 p-0">
                  <div class="row">
                    <div class="col-4">Identifier:</div>
                    <div class="col-8">{{ entity?.identifier }}</div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-4">Version:</div>
                    <div *ngIf="!options?.edit" class="col-8">
                      <b>{{ entity?.firmwareVersion }}</b>
                    </div>
                    <div *ngIf="options?.edit" class="col-8">
                      <input
                        type="text"
                        [(ngModel)]="entity.firmwareVersion"
                        (ngModelChange)="updateDefinition()"
                        size="16"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">Series:</div>
                    <div *ngIf="!options?.edit" class="col-8">
                      <b>{{ entity?.series }}</b>
                    </div>
                    <div *ngIf="options?.edit" class="col-8">
                      <input
                        type="text"
                        [(ngModel)]="entity.series"
                        (ngModelChange)="updateDefinition()"
                        size="16"
                      />
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-4">Manufacturer:</div>
                    <div *ngIf="options?.edit" class="col-8">
                      <ng-select
                        [(ngModel)]="entity.mid"
                        (ngModelChange)="updateManufacturer($event)"
                        [items]="manufacturerSelectOptions"
                        bindLabel="label"
                        bindValue="value"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="card mt-1">
                        <div class="card-header bg-dark">Files</div>
                        <div class="card-body m-0 p-0">
                          <div class="row m-1">
                            <div class="col-4">Checksum:</div>
                            <div *ngIf="!options?.edit" class="col-8">
                              <b>{{ entity?.checksum }}</b>
                            </div>
                            <div *ngIf="options?.edit" class="col-8">
                              <input
                                type="text"
                                [(ngModel)]="entity.checksum"
                                (ngModelChange)="updateDefinition()"
                                size="28"
                              />
                            </div>
                          </div>
                          <div class="row m-1">
                            <div class="col-4">Size:</div>
                            <div *ngIf="!options?.edit" class="col-8">
                              <b>{{ entity?.size }}</b>
                            </div>
                            <div *ngIf="options?.edit" class="col-8">
                              <input
                                type="text"
                                [(ngModel)]="entity.size"
                                (ngModelChange)="updateDefinition()"
                                size="16"
                              />
                            </div>
                          </div>
                          <div class="div-table-tr-alt">
                            <div class="row">
                              <div class="col-12 text-center">File</div>
                            </div>
                            <div class="row">
                              <div class="col-12 text-center">
                                <div *ngIf="!options?.edit">
                                  <b>{{ entity?.file }}</b>
                                </div>
                                <div *ngIf="options?.edit">
                                  <input
                                    style="width:100%;"
                                    type="text"
                                    [(ngModel)]="entity.file"
                                    (ngModelChange)="updateDefinition()"
                                    size="64"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="entity?.manufacturerId == '15'">
                            <div class="div-table-tr-alt">
                              <div class="row">
                                <div class="col-12 text-center">
                                  Security Storage Certificate
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 text-center">
                                  <div *ngIf="!options?.edit">
                                    <b>{{ entity?.security_certificate }}</b>
                                  </div>
                                  <div *ngIf="options?.edit">
                                    <input
                                      style="width:100%;"
                                      type="text"
                                      [(ngModel)]="entity.security_certificate"
                                      (ngModelChange)="updateDefinition($event)"
                                      size="128"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="card">
                        <div class="card-header">Notes</div>
                        <div class="card-body m-0 p-0">
                          <div class="row">
                            <div class="col-12">
                              <div *ngIf="!options?.edit">
                                <b>{{ entity?.notes }}</b>
                              </div>
                              <div *ngIf="options?.edit">
                                <textarea
                                  style="width:100%;"
                                  [(ngModel)]="entity.notes"
                                  (ngModelChange)="updateDefinition()"
                                  rows="8"
                                  cols="60"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-footer"
                  *ngIf="entity?.pending && !options?.modal_form"
                >
                  <div class="row">
                    <div class="col-12">
                      <div class="alert alert-dark">
                        Caution: Saving changes to a firmware definition will
                        clear it's approval flag, blocking units from OTAing to
                        it if currently active!
                      </div>
                    </div>
                    <div class="col-12">
                      <button
                        (click)="save(entity, $event)"
                        class="btn btn-sm btn-danger"
                        type="submit"
                      >
                        <i class="fa fa-plus-circle"></i> Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #defaultView>
      <!-- Modal Header -->
      <div
        class="modal-header bg-light d-flex justify-content-between align-items-center"
      >
        <h4 class="modal-title m-0 h5">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="mcuListModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <!-- Basic Information -->
        <div class="card mb-3">
          <div class="card-header bg-light">
            <h5 class="m-0">Basic Information</h5>
          </div>
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-3 font-weight-bold text-muted">Identifier:</div>
              <div class="col-md-9">
                {{ entity?.identifier }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3 font-weight-bold text-muted">Version:</div>
              <div class="col-md-9">
                <ng-container *ngIf="!options?.edit; else editVersion">
                  <strong>{{ entity?.firmwareVersion }}</strong>
                </ng-container>
                <ng-template #editVersion>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [(ngModel)]="entity.firmwareVersion"
                    (ngModelChange)="updateDefinition($event)"
                  />
                </ng-template>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3 font-weight-bold text-muted">Series:</div>
              <div class="col-md-9">
                <ng-container *ngIf="!options?.edit; else editSeries">
                  <strong>{{ entity?.series }}</strong>
                </ng-container>
                <ng-template #editSeries>
                  <ng-select
                    class="ng-select-sm"
                    [(ngModel)]="entity.series"
                    (ngModelChange)="updateDefinition($event)"
                    [items]="seriesSelectOptions"
                    bindLabel="label"
                    bindValue="value"
                  ></ng-select>
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 font-weight-bold text-muted">Manufacturer:</div>
              <div class="col-md-9">
                <ng-container *ngIf="options?.edit">
                  <ng-select
                    class="ng-select-sm"
                    [(ngModel)]="entity.mid"
                    (ngModelChange)="updateManufacturer($event)"
                    [items]="manufacturerSelectOptions"
                    bindLabel="label"
                    bindValue="value"
                  ></ng-select>
                </ng-container>
                <ng-container *ngIf="!options?.edit">
                  {{ getManufacturerName(entity?.mid) }}
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- Files Section -->
        <div class="card mb-3">
          <div class="card-header bg-dark text-white">
            <h5 class="m-0">Files</h5>
          </div>
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-3 font-weight-bold text-muted">Checksum:</div>
              <div class="col-md-9">
                <ng-container *ngIf="!options?.edit; else editChecksum">
                  <code>{{ entity?.checksum }}</code>
                </ng-container>
                <ng-template #editChecksum>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [(ngModel)]="entity.checksum"
                    (ngModelChange)="updateDefinition($event)"
                  />
                </ng-template>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-3 font-weight-bold text-muted">Size:</div>
              <div class="col-md-9">
                <ng-container *ngIf="!options?.edit; else editSize">
                  <strong>{{ entity?.size }}</strong>
                </ng-container>
                <ng-template #editSize>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [(ngModel)]="entity.size"
                    (ngModelChange)="updateDefinition($event)"
                  />
                </ng-template>
              </div>
            </div>

            <div>
              <div class="card">
                <div class="card-header bg-light">
                  <h6 class="m-0">File</h6>
                </div>
                <div class="card-body p-2">
                  <ng-container *ngIf="!options?.edit; else editFile">
                    <code>{{ entity?.file }}</code>
                  </ng-container>
                  <ng-template #editFile>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="entity.file"
                      (ngModelChange)="updateDefinition($event)"
                    />
                  </ng-template>
                </div>
              </div>
            </div>

            <!-- Security Certificate -->
            <div *ngIf="entity?.manufacturerId == '15'" class="card mt-2">
              <div class="card-header bg-light">
                <h6 class="m-0">Security Storage Certificate</h6>
              </div>
              <div class="card-body p-2">
                <ng-container *ngIf="!options?.edit; else editSecurityCert">
                  <code>{{ entity?.security_certificate }}</code>
                </ng-container>
                <ng-template #editSecurityCert>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="entity.security_certificate"
                    (ngModelChange)="updateDefinition($event)"
                  />
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- Release Notes -->
        <div class="card mb-3">
          <div class="card-header">
            <h5 class="m-0">Release Notes</h5>
          </div>
          <div class="card-body">
            <ng-container *ngIf="!options?.edit; else editNotes">
              <div class="p-2 bg-light rounded" *ngIf="entity?.notes">
                {{ entity?.notes }}
              </div>
              <div class="text-muted" *ngIf="!entity?.notes">
                No release notes available
              </div>
            </ng-container>
            <ng-template #editNotes>
              <textarea
                class="form-control"
                rows="5"
                [(ngModel)]="entity.notes"
                (ngModelChange)="updateDefinition($event)"
              ></textarea>
            </ng-template>
          </div>
        </div>

        <!-- Pending Warning -->
        <div *ngIf="entity?.pending" class="alert alert-warning">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Caution: Saving changes to a mcu firmware definition will clear its
          approval flag, blocking units from OTAing to it if currently active!
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-outline-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-outline-danger"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.revertMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.revert()"
          data-dismiss="modal"
        >
          {{ currentModal?.revertMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg && entity?.pending"
          type="button"
          class="btn btn-primary"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  